(() => {
  const SIZE_PROFILES = Object.freeze({
    'flow-ease-bra': {
      measurements: ['underbust', 'bust'],
      note: 'Choose the larger size for fuller bust volume, more coverage or a more comfortable underband. Choose the smaller size for a firmer fit only when coverage remains secure.',
      sizes: [
        { size: 'S', underbust: [68, 74], bust: [78, 88] },
        { size: 'M', underbust: [71, 79], bust: [81, 94] },
        { size: 'L', underbust: [77, 85], bust: [90, 101] },
      ],
    },
    'flow-wynn-bra': {
      measurements: ['underbust', 'bust'],
      note: 'Start with underbust, then check full bust. In an overlap, choose smaller for a more secure fit or larger when the smaller size reduces coverage or feels tight.',
      sizes: [
        { size: 'S', underbust: [68, 75], bust: [79, 88] },
        { size: 'M', underbust: [71, 80], bust: [81, 94] },
        { size: 'L', underbust: [78, 85], bust: [90, 100] },
      ],
    },
    'flow-drift-bra': {
      measurements: ['underbust', 'bust'],
      note: 'True to size. Choose the larger size for more coverage or underband comfort; choose the smaller size for a firmer studio fit.',
      sizes: [
        { size: 'S', underbust: [68, 74], bust: [78, 86] },
        { size: 'M', underbust: [72, 79], bust: [81, 91] },
        { size: 'L', underbust: [78, 85], bust: [89, 97] },
      ],
    },
    'poise-crossback-bra': {
      measurements: ['underbust'],
      note: 'Choose the larger size if you are sensitive to band pressure or want more coverage. Choose the smaller size only for a deliberately firmer fit.',
      sizes: [
        { size: 'S', underbust: [68, 74] },
        { size: 'M', underbust: [73, 79] },
        { size: 'L', underbust: [78, 84] },
      ],
    },
    'flow-wave-legging-78': {
      measurements: ['waist', 'hip'],
      note: 'Wave fits smaller through the waist. Choose the larger size if your waist is near the top of a range.',
      sizes: [
        { size: 'S', waist: [56, 63], hip: [84, 90] },
        { size: 'M', waist: [64, 70], hip: [89, 95] },
        { size: 'L', waist: [71, 76], hip: [94, 100] },
        { size: 'XL', waist: [77, 82], hip: [99, 105] },
      ],
    },
    'flow-stirrup-legging': {
      measurements: ['waist', 'hip'],
      note: 'Choose from waist and hip first, then use the length guide for stirrup tension.',
      sizes: [
        { size: 'S', waist: [58, 64], hip: [84, 90] },
        { size: 'M', waist: [65, 71], hip: [89, 95] },
        { size: 'L', waist: [72, 77], hip: [94, 100] },
        { size: 'XL', waist: [78, 83], hip: [99, 105] },
      ],
    },
    'hybrid-interval-short-5': {
      measurements: ['waist', 'hip'],
      note: 'For shorts, hip and upper-thigh fit take priority over height. Choose larger for less compression.',
      sizes: [
        { size: 'S', waist: [58, 64], hip: [84, 90] },
        { size: 'M', waist: [65, 71], hip: [89, 95] },
        { size: 'L', waist: [72, 77], hip: [94, 100] },
        { size: 'XL', waist: [78, 83], hip: [99, 105] },
      ],
    },
    'poise-sculpt-short': {
      measurements: ['waist', 'hip'],
      note: 'Choose larger if hips or upper thighs indicate the larger size. Stay smaller only for a firm race fit.',
      sizes: [
        { size: 'S', waist: [58, 64], hip: [84, 90] },
        { size: 'M', waist: [65, 71], hip: [89, 95] },
        { size: 'L', waist: [72, 77], hip: [94, 100] },
      ],
    },
    'hybrid-pace-tight-78': {
      measurements: ['waist', 'hip'],
      note: 'Choose larger for training comfort. Choose smaller only when both waist and hip sit clearly inside that size.',
      sizes: [
        { size: 'S', waist: [58, 64], hip: [84, 90] },
        { size: 'M', waist: [65, 71], hip: [89, 95] },
        { size: 'L', waist: [72, 77], hip: [94, 100] },
        { size: 'XL', waist: [78, 83], hip: [99, 105] },
      ],
    },
    'flow-core-legging': {
      measurements: ['waist', 'hip'],
      note: 'Prioritise waist. Choose smaller for a closer second-skin fit or larger for a more relaxed feel.',
      sizes: [
        { size: 'S', waist: [58, 66], hip: [84, 93] },
        { size: 'M', waist: [67, 74], hip: [91, 99] },
        { size: 'L', waist: [75, 82], hip: [98, 106] },
        { size: 'XL', waist: [83, 90], hip: [105, 114] },
      ],
    },
    'flow-ease-short-3': {
      measurements: ['waist', 'hip'],
      note: 'Choose smaller for a closer second-skin fit; choose larger for more coverage and a more relaxed leg opening.',
      sizes: [
        { size: 'S', waist: [58, 67], hip: [84, 94] },
        { size: 'M', waist: [66, 75], hip: [92, 101] },
        { size: 'L', waist: [74, 84], hip: [99, 109] },
      ],
    },
    'flow-line-flare': {
      measurements: ['waist', 'hip'],
      note: 'Prioritise waist. Choose smaller for a closer waist and thigh fit; choose larger for more room through the thigh.',
      sizes: [
        { size: 'S', waist: [58, 66], hip: [84, 93] },
        { size: 'M', waist: [67, 74], hip: [91, 99] },
        { size: 'L', waist: [75, 82], hip: [98, 106] },
        { size: 'XL', waist: [83, 90], hip: [105, 114] },
      ],
    },
  });

  const inRange = (value, range) => (
    Number.isFinite(value)
    && Array.isArray(range)
    && value >= range[0]
    && value <= range[1]
  );

  const indexForMeasurement = (profile, measurement, value) => (
    profile.sizes.findIndex((entry) => inRange(value, entry[measurement]))
  );

  const recommendSize = (handle, measurements, preference = 'close') => {
    const profile = SIZE_PROFILES[handle];
    if (!profile || !measurements) return null;

    const values = Object.fromEntries(profile.measurements.map((measurement) => [
      measurement,
      Number(measurements[measurement]),
    ]));
    if (profile.measurements.some((measurement) => (
      !Number.isFinite(values[measurement]) || values[measurement] <= 0
    ))) return null;

    const candidates = profile.sizes.filter((entry) => (
      profile.measurements.every((measurement) => (
        inRange(values[measurement], entry[measurement])
      ))
    ));
    if (candidates.length) {
      const selected = preference === 'relaxed'
        ? candidates[candidates.length - 1]
        : candidates[0];
      return { size: selected.size, note: profile.note };
    }

    const independentIndexes = profile.measurements.map((measurement) => (
      indexForMeasurement(profile, measurement, values[measurement])
    ));
    if (independentIndexes.some((index) => index < 0)) return null;

    const low = Math.min(...independentIndexes);
    const high = Math.max(...independentIndexes);
    if (high - low > 1) return null;

    const selected = profile.sizes[preference === 'relaxed' ? high : high];
    return selected ? { size: selected.size, note: profile.note } : null;
  };

  const initialized = new WeakSet();
  const refreshes = new WeakSet();

  const isStaleRoot = (root) => Boolean(root?.querySelector?.('.fw-size-guide__empty'));

  const getSectionId = (root) => {
    const section = root.closest?.('.shopify-section[id^="shopify-section-"]');
    if (section?.id) return section.id.replace('shopify-section-', '');

    const labelledBy = root.closest?.('[aria-labelledby]')?.getAttribute('aria-labelledby') || '';
    return labelledBy.replace(/^FormwynnSizeGuideTitle-/, '');
  };

  const findFreshRoot = (html, handle) => {
    const template = document.createElement('template');
    template.innerHTML = html;
    return Array.from(template.content.querySelectorAll('[data-size-guide-root]'))
      .find((candidate) => candidate.dataset.sizeGuideHandle === handle);
  };

  const refreshStaleRoot = async (root) => {
    if (
      !root
      || refreshes.has(root)
      || typeof fetch !== 'function'
      || typeof URL !== 'function'
      || !globalThis.location?.href
    ) return;

    const handle = root.dataset.sizeGuideHandle;
    const sectionId = getSectionId(root);
    if (!handle || !sectionId) return;

    refreshes.add(root);
    try {
      const url = new URL(globalThis.location.href);
      url.search = '';
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('_fw_size_refresh', String(Date.now()));

      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) return;

      const freshRoot = findFreshRoot(await response.text(), handle);
      if (!freshRoot || isStaleRoot(freshRoot)) return;

      root.replaceWith(freshRoot);
      initRoot(freshRoot);
    } catch (error) {
      console.warn?.('Unable to refresh Formwynn size guide.', error);
    }
  };

  const initRoot = (root) => {
    if (!root || initialized.has(root)) return;

    if (isStaleRoot(root)) {
      refreshStaleRoot(root);
      return;
    }

    initialized.add(root);

    const handle = root.dataset.sizeGuideHandle;
    const form = root.querySelector('[data-size-guide-form]');
    const output = root.querySelector('[data-size-guide-result]');
    if (!form || !output || !SIZE_PROFILES[handle]) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const measurements = {};
      form.querySelectorAll('[data-size-measure]').forEach((input) => {
        measurements[input.dataset.sizeMeasure] = Number(input.value);
      });
      const preference = form.querySelector('[name="fit_preference"]:checked')?.value
        || 'close';
      const recommendation = recommendSize(handle, measurements, preference);

      if (!recommendation) {
        output.innerHTML = '<strong>We need a closer look.</strong><span>Your measurements fall outside one clear size. Please contact us for personal fit guidance.</span>';
        return;
      }
      output.innerHTML = `<strong>Start with size ${recommendation.size}</strong><span>${recommendation.note}</span>`;
    });
  };

  const initWithin = (target) => {
    if (!target) return;
    if (target.matches?.('[data-size-guide-root]')) initRoot(target);
    target.querySelectorAll?.('[data-size-guide-root]').forEach(initRoot);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-size-guide-open]');
    if (!button) return;
    const dialog = document.getElementById(button.dataset.sizeGuideTarget);
    dialog?.showModal?.();
  });

  globalThis.FormwynnSizeGuide = Object.freeze({
    SIZE_PROFILES,
    recommendSize,
    initRoot,
  });

  initWithin(document);
  document.addEventListener('shopify:section:load', (event) => {
    initWithin(event.target);
  });
})();
